import React, { useState, useMemo } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { useHistory } from 'react-router-dom';
import {
  selectUser,
  schufaCheck,
  withTextLocalizer,
  LocalizePropType,
  getCountryListWeb,
  selectBrandSettings,
  getLicenseStatus,
  getNextUserOpenChallengeRoute,
  isV2BankFlow,
  getUser,
  isDepositRequired,
  getDepositStatus,
  setNetworkSuccess,
  CLIENT_TYPE,
} from 'getaway-data-layer';
import { useFormik } from 'formik';
import SchufaCheckView from './SchufaCheckView';
import {
  // maxBirthDate,
  // minBirthDate,
  SchufaModal,
  SchufaSchema,
} from '../../../../validation';
import {
  GA_TITLES,
  isDashboardScreen,
  navigateTo,
  reportGAEvent,
  showAlert,
} from '../../../../utils';
import AddressAutoCompleteModal from '../UpdateAddress/AddressSearchModal';

interface Values {
  firstName: string;
  lastName: string;
  dateOfBirth: any;
  streetName: string;
  streetNumber: string;
  city: string;
  postalCode: string;
  country: string;
}

type Props = {
  localize: LocalizePropType;
};

const SchufaCheckContainer = ({ localize }: Props) => {
  const history = useHistory();
  const dispatch = useDispatch();
  const user: any = useSelector(selectUser);
  const brandSettings = useSelector(selectBrandSettings);
  const licenseStatus = getLicenseStatus(user);
  const [country, setCountry] = useState(user?.address?.country || 'DE');
  const [isModalOpen, setIsModalOpen] = useState(false);

  // const [customError, setCustomError] = useState('') as any;
  const supportedCountries = useMemo(
    () =>
      getCountryListWeb(
        localize,
        brandSettings?.allowedUserAddressCountries,
        true
      ),
    []
  );
  const dateFormat = 'dd/MM/yyyy';

  const onCountryChange = (value: any) => {
    setCountry(value);
  };

  const onSubmit = (values: Values) => {
    // const formattedBirth = format(new Date(values.dateOfBirth), 'yyyy-MM-dd');
    dispatch(
      schufaCheck(
        {
          // firstName: values.firstName.trim(),
          // lastName: values.lastName.trim(),
          // dateOfBirth: formattedBirth.trim(),
          address: {
            streetName: values.streetName.trim(),
            streetNumber: values.streetNumber.trim(),
            city: values.city.trim(),
            postalCode: values.postalCode.trim(),
            country: values.country.trim(),
          },
        },
        () => {
          setTimeout(() => {
            dispatch(
              getUser(
                (updatedUser) => {
                  if (isDashboardScreen()) {
                    if (
                      brandSettings?.trueLayerSettings?.bankLoginEnabled &&
                      !isV2BankFlow()
                    ) {
                      navigateTo(history, '/dashboard/selectBank');
                    } else {
                      navigateTo(history, '/dashboard/optimizedSepa');
                    }
                  } else {
                    navigateTo(
                      history,
                      getNextUserOpenChallengeRoute(updatedUser)
                    );
                  }
                  dispatch(
                    setNetworkSuccess(CLIENT_TYPE.USER_CLIENT.SCHUFA_CHECK)
                  );
                  reportGAEvent(GA_TITLES.ON_BOARDING.SCHUFA_SUBMITTED);
                },
                () => {}
              )
            );
          }, 4000);
        },
        () => {
          navigateTo(history, '/settings');
        },
        false,
        true
      )
    );
  };

  const onClose = () => {
    if (isDashboardScreen()) {
      navigateTo(history, '/settings');
    } else {
      showAlert(
        '',
        localize('cancel.FirstSteps.dialog.message'),
        localize('cancel.FirstSteps.dialog.yes'),
        () => navigateTo(history, '/settings'),
        localize('cancel.FirstSteps.dialog.no'),
        () => {},
        true
      );
    }
  };

  const onCloseModal = () => {
    setIsModalOpen(false);
  };

  const onSearchAddressClicked = () => {
    setIsModalOpen(true);
  };

  const SchufaFormik = useFormik({
    initialValues: SchufaModal(user),
    validationSchema: SchufaSchema(localize, country),
    onSubmit,
  });

  const onLocationSelected = (location: any) => {
    SchufaFormik.setValues(location);
    setIsModalOpen(false);
  };
  return (
    <>
      <AddressAutoCompleteModal
        countryRestriction={SchufaFormik.values.country}
        isModalOpen={isModalOpen}
        onCloseModal={onCloseModal}
        onLocationSelected={onLocationSelected}
      />
      <SchufaCheckView
        localize={localize}
        supportedCountries={supportedCountries}
        formik={SchufaFormik}
        onClose={onClose}
        country={country}
        onCountryChange={onCountryChange}
        onSearchAddressClicked={onSearchAddressClicked}
        onLocationSelected={onLocationSelected}
      />
    </>
  );
};

export default withTextLocalizer(SchufaCheckContainer);
